import {offsetRect, RectType} from './rect'
import normalizeScroll from './scroll'

export type TopLeftType = {
  left: number
  top: number
}

export type OffsetsType = {
  top?: number | null
  left?: number | null
  right?: number | null
  bottom?: number | null
}

export function offsetParent(node) {
  if (node.offsetParent) return node.offsetParent
  const nodeStyle = window.getComputedStyle(node)
  let currentNode = node
  do {
    if (currentNode.tagName === 'BODY') return currentNode
    const style = window.getComputedStyle(currentNode)
    if (nodeStyle.position === 'fixed') {
      const transform =
        // @ts-ignore
        style.transform || style.webkitTransform || style.mozTransform
      if (transform && transform !== 'none') {
        return currentNode
      }
    } else if (style.position === 'relative' || style.position === 'absolute') {
      return currentNode
    }
    currentNode = currentNode.parentNode
  } while (currentNode)
  return null
}

/** Converts absolute top,left,right,bottom bounds (relative to window) to offsets relative to node's parent
 *
 * These offsets can be used to set top/left/right/bottom styles, as they are distances from parent's bounds
 *
 * */
export function absoluteBoundsToRelativeOffsets(
  node: Element | undefined | null,
  position: OffsetsType
): OffsetsType {
  if (!node) return position
  const parentElement = offsetParent(node)
  if (!parentElement) return position

  const nodeStyle = window.getComputedStyle(node)

  const parent = normalizeScroll(parentElement)
  if (!parent) return position
  let parentRect = parent.getAbsoluteBorderBox() as RectType
  if (nodeStyle.position !== 'fixed' || !parent.isWindow()) {
    // unless the node is fixed, we have to account for parent scroll (unless it's the window)
    parentRect = offsetRect(parentRect, {
      top: -parent.scrollTop,
      left: -parent.scrollLeft,
    })
  }

  const {top, left, bottom, right} = position

  const result: OffsetsType = {}
  if (top != null) result.top = top - parentRect.top
  if (left != null) result.left = left - parentRect.left
  if (bottom != null)
    result.bottom = parentRect.top + parentRect.height - bottom
  if (right != null) result.right = parentRect.left + parentRect.width - right
  return result
}
